module.exports = __webpack_public_path__ + "img/klarna-1.37cb962a.svg";